import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { EsitiDatiGeneraliForm } from 'src/app/common/form/esiti-dati-generali-form';
import { SezioneContropartiResponse } from 'src/app/common/models/dto/sezione-controparti-response';
import { FascicoloFull } from 'src/app/common/models/fascicolo/fascicolo-full';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { SezioneEsitiResponse } from '../../../models/dto/sezione-esiti-response';
import { Esito } from '../../../models/esito';
import { SezioneEsitiFull } from '../../../models/sezioni/sezione-esiti-full';
import { FormValidationService } from '../../../services/form-validation.service';
import { SezioneAltrePartiResponse } from 'src/app/common/models/dto/sezione-altre-parti-response';
import { SezioneLegaliResponse } from 'src/app/common/models/dto/sezione-legali-response';

@Component({
  selector: 'div [esiti-dati-generali-add-form]',
  templateUrl: '../../../form/esiti-dati-generali-form.html',
  host: { '[class.col-sm-12]': '\'true\'', '[class.coldx]': '\'true\'' }
})
export class EsitiAddComponent extends EsitiDatiGeneraliForm implements OnInit {

  @Output()
  onReturn: EventEmitter<SezioneEsitiFull> = new EventEmitter<SezioneEsitiFull>();

  @Output()
  onEsitoInseritoForAuto: EventEmitter<Esito> = new EventEmitter<Esito>();

  @Output()
  lastID: EventEmitter<string> = new EventEmitter<string>();

  idSezione: string;
  urlAddEsito: string;

  constructor(@Inject(HelpersService) helpers: HelpersService, @Inject(OperationsService) operations: OperationsService, @Inject(FormBuilder) campiForm: FormBuilder, @Inject(FormValidationService) formValidationService: FormValidationService) {
    super(helpers, operations, campiForm, formValidationService);
  }

  ngOnInit() {
    this.setTitle('Aggiungi esito');
    this.isInserimento(true);
  }

  getRequest(request: Esito) {
    this.operations.addEsito(this.urlAddEsito, this.idSezione, this.fascicolo.id, request).subscribe(response => this.returnSetSezEsitiOrdinario(response, request));
  }

  readSezioneControparti(idSezione, url) {
    if (idSezione) {
      this.operations.readSezione(url, idSezione).subscribe(response => {
        this.contropartiOptions = (<SezioneContropartiResponse>response).sezione.controparti;
      });
    }
  }

  readSezioneAltreParti(idSezione, url) {
    if (idSezione) {
      this.operations.readSezione(url, idSezione).subscribe(response => {
        this.altrePartiOptions = (<SezioneAltrePartiResponse>response).sezione.altreParti;
      });
    }
  }
  readSezioneLegali(idSezione, url) {
    if (idSezione) {
      this.operations.readSezione(url, idSezione).subscribe(response => {
        this.legaliOptions = (<SezioneLegaliResponse>response).sezione.legaliIncaricati;
      });
    }
  }

  returnSetSezEsitiOrdinario(response: SezioneEsitiResponse, esitoIns: Esito) {
    if (response.returnCode === 'OK') {
      this.lastID.emit(response.lastID);
      this.onReturn.emit(response.sezione);
      this.onEsitoInseritoForAuto.emit(esitoIns);
    }
  }

  inizializza(urlAddEsito: string, idSezione: string, fascicolo: FascicoloFull, urlReadSezioneControparti: string, urlReadSezioneAltreParti: string, urlReadSezioneLegali: string) {
    this.idSezione = idSezione;
    this.urlAddEsito = urlAddEsito;
    // this.urlReadPratica = urlReadPratica;
    this.fascicolo = fascicolo;
    //this.readClassificazioni(fascicolo.praticaBase.id);
    this.readSezioneControparti(fascicolo.idSezioneControparti, urlReadSezioneControparti);
    this.readSezioneAltreParti(fascicolo.idSezioneAltreParti, urlReadSezioneAltreParti);
    this.readSezioneLegali(fascicolo.idSezioneLegali, urlReadSezioneLegali);
    this.populateSelect();
    this.createForm();
  }

  getEsito(): Esito {
    return new Esito();
  }
}
